import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=35fe0a15&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=35fe0a15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fe0a15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35fe0a15')) {
      api.createRecord('35fe0a15', component.options)
    } else {
      api.reload('35fe0a15', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=35fe0a15&scoped=true&", function () {
      api.rerender('35fe0a15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/agencyExchange/detail.vue"
export default component.exports